import { StateCreator } from 'zustand';

export interface SkipWidgetLibraryInstallationState {
    skipWidgetLibraryInstallation: boolean;
    setSkipWidgetLibraryInstallation: (skip: boolean) => void;
}

export const createSkipWidgetLibraryInstallationSlice: StateCreator<
    any,
    [['zustand/persist', unknown]],
    [],
    SkipWidgetLibraryInstallationState
> = set => ({
    skipWidgetLibraryInstallation: false,
    setSkipWidgetLibraryInstallation: (skip: boolean) =>
        set({
            skipWidgetLibraryInstallation: skip,
        }),
});
